import { createFileRoute } from "@tanstack/react-router"
import { PromptPage } from "@/prompting"
import type { Uuid } from "@/utils"

export const Route = createFileRoute("/(user)/t/$tenantSlug/prompts/$id")({
  component: RouteComponent,
  validateSearch: (search) =>
    search as {
      revision?: string
      runId?: Uuid
      history?: true
    },
})

function RouteComponent() {
  const { id } = Route.useParams()
  const { revision, runId, history } = Route.useSearch()

  return (
    <PromptPage
      id={id}
      revisionIdOrTag={revision}
      runId={runId}
      history={!!history}
    />
  )
}
